import * as C from '../constants';
import TwentyService from '../../../services/twenty-service';
import SkiService from '../../../services/ski/ski-service';

export default {

  /**
   * @param commit
   * @returns {Promise<T>}
   */
  xmlChannels({ commit }, type) {
    commit(C.XML_CHANNELS_LOAD_PENDING);
    return SkiService.getXmlChannelsByType(type)
      .then(res => {
        commit(C.XML_CHANNELS_LOAD_SUCCESS, res.data);
      })
      .catch(() => {
        commit(C.XML_CHANNELS_LOAD_FAILURE);
      });
  },

  /**
   * @param commit
   * @param type
   * @param xmlChannelId
   * @returns {Promise<T>}
   */
  xmlProducts({ commit }, type, xmlChannelId) {
    commit(C.XML_PRODUCTS_LOAD_PENDING);
    return SkiService.getXmlProductsByType(type, xmlChannelId)
      .then(res => {
        commit(C.XML_PRODUCTS_LOAD_SUCCESS, { type, items: res.data.sort((a, b) => a.tbName.localeCompare(b.tbName)) });
      })
      .catch(() => {
        commit(C.XML_PRODUCTS_LOAD_FAILURE);
      });
  },

  /**
   * Retrieve a list of countries.
   *
   * @param commit
   * @returns {Promise<any>}
   */
  countriesLoad({ commit }) {
    commit(C.TWENTY_COUNTRIES_LOAD_PENDING);
    return TwentyService.getCountries()
      .then(res => {
        const countries = {};
        res.data.forEach(country => {
          countries[country.id] = {
            id: country.id,
            name: country.name,
          };
        });
        commit(C.TWENTY_COUNTRIES_LOAD_SUCCESS, countries);
      })
      .catch(err => {
        commit(C.TWENTY_COUNTRIES_LOAD_FAILURE, err.response.data);
      });
  },

  /**
   * Retrieve a list of areas for a country.
   *
   * @param commit
   * @param payload
   * @returns {Promise<any>}
   */
  areasLoad({ commit }, payload) {
    commit(C.TWENTY_AREAS_LOAD_PENDING);
    return TwentyService.getAreasForCountry(payload)
      .then(res => {
        commit(C.TWENTY_AREAS_LOAD_SUCCESS, res.data);
      })
      .catch(err => {
        commit(C.TWENTY_AREAS_LOAD_FAILURE, err.response.data);
      });
  },

  /**
   * Retrieve a list of all sites.
   *
   * @param commit
   * @param payload
   * @returns {Promise<any>}
   */
  sitesLoad({ commit }) {
    commit(C.TWENTY_SITES_LOAD_PENDING);
    return TwentyService.getSites()
      .then(res => {
        commit(C.TWENTY_SITES_LOAD_SUCCESS, res.data);
      })
      .catch(err => {
        commit(C.TWENTY_SITES_LOAD_FAILURE, err.response.data);
      });
  },

  /**
   * Clear the current loaded areas.
   *
   * @param commit
   */
  areasClear({ commit }) {
    commit(C.TWENTY_AREAS_CLEAR);
  },

  copyAndTranslateContent({ commit }, payload) {
    return TwentyService.copyAndTranslateContent(payload).then(res => {
      commit(C.TWENTY_COPY_AND_TRANSLATE_CONTENT_SUCCESS, res.data);
    }).catch(err => {
      commit(C.TWENTY_COPY_AND_TRANSLATE_CONTENT_FAILURE, err.response.data);
    });
  },

  getDomains({ commit }) {
    return TwentyService.getDomainsByProductTypeId(2).then(res => {
      commit(C.TWENTY_DOMAIN_SUCCESS, res.data);
    }).catch(err => {
      commit(C.TWENTY_DOMAIN_FAILURE, err.response.data);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/twenty/actions.js